import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import materialStore from './components/materials/store'
import storageStore from './components/storage/store'
import eventStore from './components/events/store'
import adminStore from './components/admin/store'
import gewerkeStore from './components/gewerke/store'

export default createStore({
  state: {
    darkMode: true,
    loginDialogVisible: false,
  },
  modules: {
    materialStore,
    storageStore,
    eventStore,
    adminStore,
    gewerkeStore
  },
  actions: {},
  mutations: {
    openLoginDialog(state) {
      state.loginDialogVisible = true
    },
    closeLoginDialog(state) {
      state.loginDialogVisible = false
    }
  },
  getters: {},
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})
